import { makeStyles } from "@mui/styles";
import React from "react";
import E_exec1 from "../../asset/E_exec1.png";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWdith: 270,
    width: 270,
    // height: 300,
    display: "flex",
    flexDirection: "column",
    // border: "3px solid orange",
  },
  moduleImg: {
    // width: 230,
    height: 170,
    borderBottom: "1px solid orange",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fcf5e3",
  },
  moduleTxt: {
    width: 230,
    height: 193,
    display: "flex",
    // border: "1px solid blue",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "#fcf5e3",
    // paddingLeft: 5,
  },
}));

export const MbaMobileE1 = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <img src={E_exec1} className={classes.moduleImg} alt="img_E_exec1" />
    </div>
  );
};
